import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defer, indexOf } from 'lodash';

// Import Selectors
import { getUser, getIsUsingOrganizationSwitch, getIsAdmin, getIsSuperAdmin } from '../../modules/Auth/AuthReducer';

// Note: only superadmin/admin or PI with proper rights can use OrganizationSwitch

export default (ComposedComponent, permissions = [], redirect = null) => {
  class CheckOrganizationPermission extends Component {
    redirect() {
      if (redirect) {
        const { location: { pathname } } = this.props;
        if (pathname !== redirect) {
          defer(this.context.router.history.push, redirect);
        }
      }
    }

    render() {
      const {
        user, isUsingOrganizationSwitch, isSuperAdmin, isAdmin,
      } = this.props;
      if (!user._id) {
        return null;
      }
      const organizationRole = user.organization_role;
      if (!isSuperAdmin && !isAdmin && !isUsingOrganizationSwitch && indexOf(permissions, organizationRole) < 0) {
        this.redirect();
        return null;
      }
      return <ComposedComponent {... this.props} />;
    }
  }

  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      user: getUser(state),
      isAdmin: getIsAdmin(state),
      isSuperAdmin: getIsSuperAdmin(state),
      isUsingOrganizationSwitch: getIsUsingOrganizationSwitch(state),
    };
  }

  CheckOrganizationPermission.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.shape({}).isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    isUsingOrganizationSwitch: PropTypes.bool.isRequired,
    user: PropTypes.shape({
      user_id: PropTypes.string,
    }).isRequired,
  };

  CheckOrganizationPermission.contextTypes = {
    router: PropTypes.object,
  };

  return connect(mapStateToProps)(CheckOrganizationPermission);
}
